import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import { API_BASE } from "../config";
import { authHeaders } from "../utils/authHeaders";

export default function ProductCategories() {
  const [categories, setCategories] = useState([]);
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const loadCategories = async () => {
    setLoading(true);
    setMessage("");

    try {
      const res = await fetch(`${API_BASE}/masters/product-categories`, {
        headers: authHeaders(),
      });

      const data = await res.json();

      if (!res.ok || data.success === false) {
        throw new Error(data.message || "Failed to load categories");
      }

      setCategories(Array.isArray(data.data) ? data.data : []);
    } catch (err) {
      console.error("Load categories error:", err);
      setMessage(err.message || "Failed to load categories");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadCategories();
  }, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    setMessage("");

    if (!name.trim()) {
      setMessage("Category name is required");
      return;
    }

    try {
      const res = await fetch(`${API_BASE}/masters/product-categories`, {
        method: "POST",
        headers: authHeaders({
          "Content-Type": "application/json",
        }),
        body: JSON.stringify({ name }),
      });

      const data = await res.json();

      if (!res.ok || data.success === false) {
        throw new Error(data.message || "Failed to create category");
      }

      setName("");
      setMessage("Category created successfully");
      loadCategories();
    } catch (err) {
      console.error("Create category error:", err);
      setMessage(err.message || "Failed to create category");
    }
  };

  return (
    <div style={{ display: "flex" }}>
      <Sidebar />

      <div style={{ padding: 24, width: "100%" }}>
        <h2>Product Category Master</h2>

        <p style={{ color: "#555" }}>
          Super Admin can create common product categories. FPO Admins will only select from this list.
        </p>

        {message && (
          <div
            style={{
              marginBottom: 16,
              padding: 10,
              background: "#f5f5f5",
              border: "1px solid #ddd",
            }}
          >
            {message}
          </div>
        )}

        <form
          onSubmit={handleCreate}
          style={{
            display: "flex",
            gap: 10,
            alignItems: "end",
            marginBottom: 24,
            maxWidth: 600,
          }}
        >
          <div style={{ flex: 1 }}>
            <label>Category Name *</label>
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g. Seed, Fertilizer, Animal Feed"
              style={{ width: "100%", padding: 8 }}
            />
          </div>

          <button
            type="submit"
            style={{
              padding: "9px 14px",
              background: "#1976D2",
              color: "#fff",
              border: "none",
              cursor: "pointer",
            }}
          >
            Create
          </button>
        </form>

        <h3>Category List</h3>

        {loading ? (
          <p>Loading...</p>
        ) : (
          <table
            border="1"
            cellPadding="8"
            cellSpacing="0"
            style={{ borderCollapse: "collapse", width: "100%", maxWidth: 800 }}
          >
            <thead>
              <tr style={{ background: "#f0f0f0" }}>
                <th>ID</th>
                <th>Category Name</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {categories.length === 0 ? (
                <tr>
                  <td colSpan="3" style={{ textAlign: "center" }}>
                    No category found
                  </td>
                </tr>
              ) : (
                categories.map((cat) => (
                  <tr key={cat.id}>
                    <td>{cat.id}</td>
                    <td>{cat.name}</td>
                    <td>{cat.is_active ? "Active" : "Inactive"}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}